var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{on:{"click":_vm.startGame}},[(_vm.isVisibleTopPage)?_c('Top'):_vm._e(),(_vm.isVisibleMainPage)?_c('Main'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }